import React, { useState } from 'react';
import { RoundedButton } from './RoundedButton';
import { FiShare } from 'react-icons/fi';
import { SocialStepEnum } from '../enums/social-step';
import { VKShareButton, FacebookShareButton, TwitterShareButton, OKShareButton } from 'react-share';
import styled, { css } from 'styled-components'
import { commonService } from '../services/commonService';

const RoundedButtonClickable = styled(RoundedButton)`
  ${({ isCopied }) =>  {
    if (isCopied) {
      return css`
        background: #f9d606;
        color: black;
      `
    }
  }}
`

export const SharingList = ({ goNextStep, pin, copyToClipboard }) => {
  const currentUrl = commonService.locationHref; 
  const [ isCopied, setCopied ] = useState(false);

  const handleCopyToClipboard = (event) => {
    setCopied(true);
    copyToClipboard(event);
    handleShareClick('copy_link')();
  }

  const handleShareClick = (socialOrCopy) => {
    return () => {
      commonService.sendEvent({ category: 'share' })
      commonService.sendEvent({ category: `share_${socialOrCopy}` });
    }
  }

  return (
    <div className="Social-List">
      { pin.socialStep === SocialStepEnum.SHARE_IT && (
        <RoundedButton handleClick={goNextStep} Icon={FiShare}>
          Поделиться!
        </RoundedButton>
      )}
      { pin.socialStep === SocialStepEnum.SHARE_SELECTION && (
        <>
          <div className="Social-List__header">Поделиться</div>
          <div className="Social-List__content">
            <RoundedButtonClickable isCopied={isCopied} handleClick={handleCopyToClipboard}>
             { isCopied ? 'Скопировано!' : 'Скопировать ссылку' }
            </RoundedButtonClickable>
            <VKShareButton className="Social-List__button" url={currentUrl} onClick={handleShareClick('vk')}>
              <RoundedButton>Вконтакте</RoundedButton>
            </VKShareButton>
            <FacebookShareButton className="Social-List__button" url={currentUrl} onClick={handleShareClick('fb')}>
              <RoundedButton>Facebook</RoundedButton>
            </FacebookShareButton>
            <TwitterShareButton className="Social-List__button" url={currentUrl} onClick={handleShareClick('twitter')}>
              <RoundedButton>Twitter</RoundedButton>
            </TwitterShareButton>
            <OKShareButton className="Social-List__button" url={currentUrl} onClick={handleShareClick('ok')}>
              <RoundedButton>Одноклассники</RoundedButton>
            </OKShareButton>
          </div>
        </>
      ) }
    </div>
  )
}
